import React from 'react'

const FareBreakdown = ({ fareBreakdowns }) => {
	return (
		fareBreakdowns && fareBreakdowns.map((breakdown) => {
			return (
				<>
					{/* {breakdown.Fares && breakdown.Fares.map((fare) => {
						return (
							<div>
								<div>{fare.Type}</div>
								<div>{fare.Amount}</div>
								<div>{fare.Currency}</div>
							</div>
						)
					})}
					<div>
						{breakdown.Passenger.QTY}
						{breakdown.Passenger.Code}
					</div> */}
					{breakdown.Taxes && breakdown.Taxes.length > 0 &&
						<>
							<p className='text-muted-foreground text-xs py-1'>Taxes Breakdown</p>
							<table className="w-full text-muted-foreground text-sm">
								{breakdown.Taxes.map((tax) => {
									return (
										<tr>
											<td className='py-1'>{tax.Code}-{tax.Country}</td>
											<td className='text-right py-1'>{tax.Currency} {tax.Amount}</td>
										</tr>
									)
								})}
							</table>
						</>
					}
				</>
			)
		})
	)
}

export default FareBreakdown
